import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { IState, ISuccessAction, IFailureAction } from 'interfaces/delete-duck';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: [],
    failure: ['error'],
    reset: [],
  },
  { prefix: 'DELETE_CARRIER_AREA_CONTACT_' }
);

export interface DeleteCarrierAreaContactState extends IState {}

const INITIAL_STATE: DeleteCarrierAreaContactState = {
  loading: false,
  error: null,
};

const request = (state: DeleteCarrierAreaContactState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: DeleteCarrierAreaContactState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: DeleteCarrierAreaContactState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteCarrierAreaContact = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteCarrierAreaContactTypes = Types;
export const DeleteCarrierAreaContactActions = Creators;
